export default "__VITE_ASSET__Dy7J0f_m__"